import * as React from 'react'
import { Button } from '@/ui'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { Modal } from '@/modules/settings/components/modal/Modal'

type ImportUserModalProps = {
  isOpen: boolean
  pending?: boolean
  onCancel: () => void
  onSubmit: (key: string) => void
}

export const ImportUserModal: React.FC<ImportUserModalProps> = ({
  isOpen,
  pending,
  onCancel,
  onSubmit,
}) => {
  const { t } = useLocalize()
  const [key, setKey] = React.useState('')

  // Reset form when modal opens
  React.useEffect(() => {
    if (isOpen) {
      setKey('')
    }
  }, [isOpen])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (key.trim()) {
      onSubmit(key.trim())
    }
  }

  return (
    <Modal isOpen={isOpen} title={t('usersModule.importViaKey')} onClose={onCancel}>
      <form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-gap-4">
        <div>
          <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">
            {t('usersModule.userKey')}
          </label>
          <input
            type="text"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder={t('usersModule.enterUserKey')}
            className="tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-border-blue-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500"
            required
          />
          <p className="tw-mt-1 tw-text-xs tw-text-gray-500">
            {t('usersModule.importKeyDescription')}
          </p>
        </div>

        <div className="tw-mt-4 tw-flex tw-justify-end tw-gap-2">
          <Button
            type="button"
            variant="secondary"
            size="sm"
            className="tw-rounded-lg tw-px-4"
            onClick={onCancel}
            disabled={pending}
          >
            {t('common.cancel')}
          </Button>
          <Button
            type="submit"
            size="sm"
            className="tw-rounded-lg tw-px-4"
            disabled={pending || !key.trim()}
          >
            {t('usersModule.importUser')}
          </Button>
        </div>
      </form>
    </Modal>
  )
}


